export default __webpack_public_path__ + "static/media/friends.4170417c.jpg";